// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  linebertyBookingServer: 'https://api-booking.winter.lineberty.net/',
  linebertyBookingApiVersionV1: 'v1',
  linebertyBookingApiVersionV2: 'v2',
  linebertyValidationServer: 'https://api-validation.winter.lineberty.net/',
  linebertyValidationApiVersion: 'v1',
  linebertyServerUrl: 'https://uat-validation.lineberty.net/api/',
  linebertyApiVersion: 'v1',
  applicationServerUrl: 'https://gw.winter.lineberty.net/appdevicemanager/api/',
  applicationServerVersion: 'v1',
  bookingServerUrl: 'https://gw.winter.lineberty.net/appbooking/api/mobileapps/',
  bookingServerVersion: 'v1',
  timetableServerUrl: 'https://gw.winter.lineberty.net/apptimetable/api/',
  timetableServerVersion: 'v1',
  endpointServerUrl: 'https://gw.winter.lineberty.net/appendpoint/api/',
  endpointServerVersion: 'v1',
  authentificationServerUrl: 'https://gw.winter.lineberty.net/appauth/api/',
  authentificationServerVersion: 'v2'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error'  // Included with Angular CLI.
